import { css } from "styled-components";

export type FlexSharedProps = {
  $justifyContent?: string;
  $alignItems?: string;
  $flexDirection?: string;
  $gap?: number | string;
};

export const FlexShared = css<FlexSharedProps>`
  display: flex;
  justify-content: ${({ $justifyContent }) =>
    $justifyContent || "space-between"};
  align-items: ${({ $alignItems }) => $alignItems || "center"};
  flex-direction: ${({ $flexDirection }) => $flexDirection || "row"};
  ${({ $gap }) =>
    $gap !== undefined &&
    `gap: ${typeof $gap === "number" ? `${$gap}px` : $gap};`}
`;
